import { Utils } from "../../core/utils";
import { TagService } from "../../tags/tag.service";
import { Note } from "../shared/note.model";
import { DisplayNote } from "ng/src/app/notes/note-display/note-display.model";

export class NotesTableDataRow {
	static fromNotes(notes: Note[], getTagsString = false, getAbridgedNote = true): NotesTableDataRow[] {
		return notes.map(note => {
			const dataRow = {
				...note,
				...getTagsString && { tagsDisplayString: TagService.getTagsAsCSVString(note.tagValues) },
				noteTimeDate: new Date(note.noteTime)
			} as NotesTableDataRow;

			getAbridgedNote && DisplayNote.setAbridgedNote(dataRow);
			
			return dataRow;
		})
	}
}

export interface NotesTableDataRow extends DisplayNote<Note> {
	fullName: string;
	noteTimeDate: Date;
	tagsDisplayString?: string;
}

export type NoteColumnField = 'timeframe' | 'turnover' | 'acknowledgments' | 'createdBy' | 'note' | 'priority' | 'tags' | 'updated' | 'updatedBy';
export type SortField = 'timeframe' | 'maxPriority' | 'createdBy' | 'updatedBy';
/**
 * HTML table headers and cells will be rendered for the specific column key fields passed in here.
 */
export class NoteColumn {
	field: NoteColumnField;
	header: string;
	show: boolean;

	/**
	 * Pass in an accepted column key and an optional header. In lieu of a header arg, the header will
	 * be created by title-casing the field arg.
	 */
	constructor(field: Exclude<NoteColumnField, 'timeframe' | 'turnover'>, header?: string, show: boolean = true) {
		this.field = field;
		this.header = header || Utils.camelToTitleCase(field);
		this.show = show;
	}
}

export type ButtonState = 'VISIBLE' | 'HOVER' | 'DISABLED';